import React, { useEffect, useCallback, useState} from 'react';
import { Path} from 'react-konva';
import PlaneHistory from './PlaneHistory.js';
import Colors from 'components/Colors.js';
import {connect} from 'react-redux';

const colors = new Colors();

const PlaneGroup = ({group}) => { 
    let parameters = group._parameters.filter(
        x => !x.planeMacro);
    let macros = Array.from(new Set(group._parameters.filter(
        x => x.planeMacro).map(x => x.planeMacro)));
    let points = parameters.map(p => p.getCoordinates());
    points = [... points, ... macros.map(m => m.coordinates)];
    let curve = "M " + points.map(point => point.x + ' ' + point.y).join(', ');
    return (
        <Path
          dash={[1]}
          stroke={colors.getColorForHash(group.id)}
          strokeWidth={1}
          data={curve} className="group-path"/>
    );
}

const mapStateToProps = (state, props) => {
    let x ={
        macros: state.plane.macros[props.group.effect.id]
    };
    props.group._parameters.map(
        p => x[p.id] = p.get(true));
    props.group._parameters.map(
        p => x[p.id + 'depth'] = p.depth);
    return x;
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PlaneGroup);
